import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-remote-patient-monitoring',
  templateUrl: './public-remote-patient-monitoring.component.html',
  styleUrls: ['./public-remote-patient-monitoring.component.scss']
})
export class PublicRemotePatientMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
